import { DndHandle } from "./DndHandle";
import { DndHandleButton } from "./DndHandleButton";
import { DndSortLine } from "./DndSortLine";
import { DndZone } from "./DndZone";

export const Dnd = {
  Handle: DndHandle,
  HandleButton: DndHandleButton,
  SortLine: DndSortLine,
  Zone: DndZone,
};
